
<div class="course-form">
  <header class="cf-head">
    <span class="cf-head__icon"><i class="fas fa-sticky-note" aria-hidden="true"></i></span>
    <div class="cf-head__text">
      <h1 class="cf-head__title">Lesson Notes</h1>
      <p class="cf-head__sub">Page {{currentPage}} of {{lessonnote.length}}</p>
    </div>
    <div class="cf-head__actions">
      <button class="btn btn--warning m-0" (click)="goback()" type="button">Cancel</button>
      <button class="btn m-0" (click)="saveNotes()" type="button"><i class="fas fa-save" aria-hidden="true"></i> Save</button>
    </div>
  </header>

  <section class="cf-card">
    <div class="d-flex justify-content-between flex-wrap gap-1.5 mb-3">
      <div class="d-flex flex-wrap gap-1.5">
        <button class="btn btn--sm m-0" (click)="previousPage()" type="button" [disabled]="currentPage == 1">
          <i class="fa fa-angle-left"></i> Previous
        </button>
        <button class="btn btn--sm m-0" (click)="nextPage()" type="button" [disabled]="this.currentPage == this.lessonnote.length">
          Next <i class="fa fa-angle-right"></i>
        </button>
      </div>
      <div class="d-flex flex-wrap gap-1.5">
        <button class="btn btn--sm m-0" (click)="addPage()" type="button">
          <i class="fa fa-plus"></i> Add Next Page
        </button>
        <button class="btn btn--warning btn--sm m-0" (click)="popconfirmdeletenote()" type="button">
          <i class="fa fa-trash"></i> Delete Page
        </button>
      </div>
    </div>

    <div class="fieldset fieldset--lg">
      <label for="title" class="legend">Note Title</label>
      <input type="text" name="title" class="text-field" [(ngModel)]="title">
    </div>
    <div class="fieldset fieldset--note mb-0">
      <quill-editor placeholder="Enter Lesson Note" classes="ql-container--lg" #editor></quill-editor>
    </div>
  </section>

  <div class="cf-footer">
    <span class="cf-footer__hint">
      <i class="fas fa-photo-video" aria-hidden="true"></i>
      <span>Use the toolbar above to insert links, media library files or a YouTube/Vimeo video.</span>
    </span>
    <span class="cf-footer__actions">
      <button class="btn btn--warning m-0" (click)="goback()" type="button">Cancel</button>
      <button class="btn m-0" (click)="saveNotes()" type="button">Save</button>
    </span>
  </div>
</div>

<div class="modal fade" #mediaModal tabindex="-1" role="dialog" aria-labelledby="mediaModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="mediaModalLabel">Select Media</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-module-media-library [classid]="this.classid" [enableselect]="true"
          (mediaSelected)="mediaSelected($event)"></app-module-media-library>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn--warning" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" #externalMediaModal tabindex="-1" role="dialog" aria-labelledby="externalMediaModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="externalMediaModalLabel">Select Media</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-add-external-media #addExternalMediaComponent></app-add-external-media>
      </div>
      <div class="modal-footer justify-content-center gap-1.5">
        <button type="button" class="btn m-0" (click)="externalMediaSelected()"
          [disabled]="!addExternalMediaComponent.iframeurl">Ok</button>
        <button type="button" class="btn btn--warning m-0" (click)="closeExternalMediaModal()">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" #urlLinkModal id="urlLinkModal" tabindex="-1" role="dialog"
  aria-labelledby="urlLinkModal" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="urlLinkModal">Insert Link</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="fieldset w-100 mb-3">
          <label class="legend" for="linkplaceholder">Enter Placeholder <span class="requiredfield">*</span></label>
          <input type="text" name="linkplaceholder" id="linkplaceholder" class="text-field" [(ngModel)]="linkPlaceholder"
            placeholder="The text students will see" required="required">
        </div>
        <div class="fieldset w-100 mb-0">
          <label class="legend" for="linkurl">Enter URL <span class="requiredfield">*</span></label>
          <input type="url" name="linkurl" id="linkurl" class="text-field" [(ngModel)]="linkUrl"
            placeholder="https://..." required="required">
        </div>
      </div>
      <div class="modal-footer justify-content-center gap-1.5">
        <button type="button" class="btn m-0" (click)="insertLinkUrl()"
          [disabled]="!linkUrl.trim() || !linkPlaceholder.trim()">Ok</button>
        <button type="button" class="btn btn--warning m-0" (click)="closeLink()">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="deleteLessonnote" data-keyboard="false" data-backdrop="static" aria-hidden="true"
  role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Delete Note</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <p class="text-center pb-2">Are you sure you want to delete this page?</p>
        <div class="d-flex justify-content-center flex-wrap gap-1.5">
          <button type="submit" class="btn btn--danger m-0" (click)="preDeletePage()">Delete</button>
          <button type="button" class="btn m-0" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
